import "./FeaturedBlog.css";
import { Calendar, Clock, ArrowRight } from "lucide-react";

const FeaturedBlog = ({
  image,
  category,
  title,
  description,
  readTime,
  date,
}) => {
  return (
    <section className="featured-blog-section">

      <div className="featured-blog-container">

        <span className="featured-heading">
          FEATURED ARTICLE
        </span>

        <div className="featured-blog-card">

          <div className="featured-blog-image">

            <img
              src={image}
              alt={title}
            />

            <span className="featured-tag">
              FEATURED
            </span>

          </div>

          <div className="featured-blog-content">

            <span className="featured-category">
              {category}
            </span>

            <h2>{title}</h2>

            <p>{description}</p>

            <div className="featured-blog-meta">

              <div>
                <Clock size={15}/>
                {readTime}
              </div>

              <div>
                <Calendar size={15}/>
                {date}
              </div>

            </div>

            <button className="featured-blog-button">

              Read Article

              <ArrowRight size={18}/>

            </button>

          </div>

        </div>

      </div>

    </section>
  );
};

export default FeaturedBlog;